import MenuItem from "@Front/Components/DesignSystem/Menu/MenuItem";
import { Routes } from "@Front/Config/Routes";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

type CommonMenuNavItemsProps = {
	isClientOrThirdParty: boolean;
	userGuidePath: string;
};

export function CommonMenuNavItems(props: CommonMenuNavItemsProps): React.ReactElement {
	const { isClientOrThirdParty, userGuidePath } = props;
	const menuLabels = COMMON_UI_I18N.navigationMenu.common;
	return (
		<>
			{isClientOrThirdParty ? (
				<MenuItem item={{ text: menuLabels.myFolders, link: Routes.pages.Folder.Select, hasSeparator: false }} />
			) : (
				<MenuItem item={{ text: menuLabels.myAccount, link: Routes.pages.MyAccount, hasSeparator: true }} />
			)}
			<MenuItem item={{ text: menuLabels.userGuide, link: userGuidePath, target: "_blank" }} />
			<MenuItem item={{ text: menuLabels.support, link: "https://tally.so/r/mBGaNY", target: "_blank" }} />
			<MenuItem item={{ text: menuLabels.cgu, link: "/CGU_LeCoffre_io.pdf", hasSeparator: true }} />
		</>
	);
}
